import type {
  ApiResponse,
  Notification,
  NotificationFilters,
  SendNotificationRequest,
  UpdateNotificationRequest
} from '../../types/ApiTypes';
import { apiManager } from '../api/ApiManager';

export class NotificationService {
  async sendNotification(data: SendNotificationRequest): Promise<ApiResponse> {
    return apiManager.post('/api/v1/admin/notifications/send', data);
  }

  async getNotifications(filters?: NotificationFilters): Promise<ApiResponse<Notification[]>> {
    return apiManager.get<Notification[]>('/api/v1/admin/notifications', filters);
  }

  async cancelNotification(id: string): Promise<ApiResponse> {
    return apiManager.put(`/api/v1/admin/notifications/${id}/cancel`);
  }

  async updateNotification(id: string, data: UpdateNotificationRequest): Promise<ApiResponse> {
    return apiManager.put(`/api/v1/admin/notifications/${id}`, data);
  }

  async resendNotification(id: string): Promise<ApiResponse> {
    return apiManager.post(`/api/v1/admin/notifications/${id}/resend`);
  }
}

export const notificationService = new NotificationService();